<template>
    <textarea ref="editor"></textarea>
</template>
<script>
import EasyMDE from "easymde";
export default {
  props: ["value"],
  data() {
    return {
      editor: null
    };
  },
  mounted() {
    this.editor = new EasyMDE({
      element: this.$refs.editor,
      toolbar: [
        "bold",
        "italic",
        "heading",
        "|",
        "quote",
        "unordered-list",
        "ordered-list",
        "|",
        "preview"
      ],
      spellChecker: false
    });
    this.editor.codemirror.on("change", (editor, changeObj) => {
      if (this.editor.value() != this.value) {
        this.$emit("input", this.editor.value());
      }
    });
    this.editor.value(this.value ? this.value : "");
  },
  watch: {
    value(value) {
      if (this.editor.value() != this.value) {
        this.editor.value(value ? value : "");
      }
    }
  }
};
</script>
<style>
.editor-toolbar button {
  background: none;
  border: 0;
}
.editor-preview-active,
.editor-preview-active-side {
  padding: 15px;
  background-color: #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/components/MarkdownEditor.vue